<template>
  <div id="mockList" class="container">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <div class="mx-auto center pt-8 w-100">
          <!-- TODO supersimulado chumbado -->
          <h2 class="bold">Simulado CFP®</h2>
          <h4>Sábado, 28 de junho de 2025</h4>
          <div class="mx-auto text-center pt-3">
            <h5>Módulo 1 e 2 - 9:00 às 13:00</h5>
            <h5>Módulo 3, 4, 5 e 6 - 15:00 às 18:00</h5>
          </div>
        </div>

        <div class="mx-auto start-button">
          <v-btn
            v-if="mock > 0"
            @click="startMock(mock)"
            color="primary"
            depressed
            large
          >
            <v-icon left>play_arrow</v-icon>
            COMEÇAR
          </v-btn>

          <!-- TODO supersimulado chumbado -->
          <div v-else-if="mock === 0">
            <v-btn
              :loading="isUpdating"
              color="primary"
              depressed
              large
              href="/simulados/cfp-50"
            >
              Em breve
            </v-btn>
            <p class="info-p">
              (A página será atualizada no horário de início)
            </p>
          </div>
          <div v-else-if="mock < 0">
            Edição encerrada! Aguarde a próxima
            <br />
            <v-btn
              :loading="isUpdating"
              :disabled="resultDisabled"
              color="primary"
              depressed
              large
              @click="getResult"
            >
              {{
                this.resultDisabled
                  ? "Resultado não encontrado"
                  : "Ver meu resultado"
              }}
            </v-btn>
          </div>
        </div>

        <a
          class="mx-auto center mt-8"
          target="_blank"
          href="https://mepassa.professorlucassilva.com.br/pagina-instrucoes-simulado-cfp"
        >
          Instruções para o simulado
        </a>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import MockService from "@/services/mocks.service";

export default {
  components: {
    MockService,
  },
  data() {
    return {
      isUpdating: false,
      mock: 0,
      loading: true,
      mockSetIntervalId: null,
      resultDisabled: false,
    };
  },
  computed: {
    authenticated() {
      return this.$store.state.auth.user !== null;
    },
  },

  watch: {
    mock(newMock, oldMock) {
      if (newMock != 0) {
        clearInterval(this.mockSetIntervalId);
      }
    },
  },

  created() {
    this.isUpdating = true;
    this.setCurrentEditionMock();

    if (!this.authenticated) {
      window.getApp.sendSnackMessage(
        "Você precisa estar logado para fazer o simulado 😉",
      );
    }
  },
  mounted() {
    this.setIntervalGetCurrentEditionMockId();
  },

  beforeDestroy() {
    clearInterval(this.mockSetIntervalId);
  },

  methods: {
    startMock(mock_id) {
      this.$router.push({ name: "event.mocks.start", params: { id: mock_id } });
    },

    getResult() {
      this.isUpdating = true;
      MockService.getCurrentResult()
        .then((response) => {
          console.log("result", response);
          if (response.data.result) {
            this.isUpdating = false;
            this.$router.push({
              name: "event.mocks.result",
              params: {
                user: response.data.user,
                result: response.data.result,
              },
            });
          }
          this.isUpdating = false;
          this.resultDisabled = true;
        })
        .catch((error) => {
          this.isUpdating = false;
          this.resultDisabled = true;
        });
    },

    setCurrentEditionMock() {
      MockService.startEventMock().then((resp) => {
        this.mock = resp;
        this.isUpdating = false;
      });
    },

    setIntervalGetCurrentEditionMockId() {
      const fifteenMinutesInMs = 600000;
      this.mockSetIntervalId = setInterval(() => {
        this.setCurrentEditionMock();
      }, fifteenMinutesInMs);
    },
  },
};
</script>

<style scoped>
.start-button {
  width: 100%;
  text-align: center;
  padding-top: 50px;
}
h6 {
  font-weight: 300;
}
.info-p {
  font-size: 14px;
  margin-top: 5px;
}
</style>
